import { Component } from '@angular/core';
// Cache bust: 2025-08-22-18:30:00

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
})
export class PublicComponent {}
